export default {"src":"/_next/static/media/HYMC.76a376e3.svg","height":18,"width":18};